
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D6DBEA","d":"M32.955 8.187l.098.081 23.628 22a1 1 0 01-1.265 1.544l-.097-.08L51 27.71V50a4 4 0 01-3.8 3.995L47 54H17a4 4 0 01-3.995-3.8L13 50V27.833l-4.33 3.91a1 1 0 01-1.322.015l-.09-.088a1 1 0 01-.016-1.322l.088-.09 24.372-22a1 1 0 011.253-.071zm-.593 2.169L15 26.028V50a2 2 0 001.85 1.995L17 52h30a2 2 0 001.995-1.85L49 50V26h.163L32.362 10.356zM26 48a1 1 0 110 2h-6a1 1 0 110-2h6zm9 0a1 1 0 110 2h-6a1 1 0 110-2h6zm9 0a1 1 0 110 2h-6a1 1 0 110-2h6z"}})])
          )
        }
      }
    